import { FC, Suspense } from 'react';
import { useLazyLoadQuery } from 'react-relay';
import BetaWelcomeDialog from './BetaWelcomeDialog';
import CustomErrorBoundary from '../../components/LayoutWrapper/CustomErrorBoundary';
import { getBetaNavigationVideoUrl } from '../../graphQLOperations/BetaNavigation';
import { BetaNavigationVideoUrlQuery } from '../../graphQLOperations/__generated__/BetaNavigationVideoUrlQuery.graphql';

interface Props {
  isAdmin: boolean;
  onStart: () => void;
  onDismiss: () => void;
}

const BetaWelcomeWithVideo: FC<Props> = ({ isAdmin, onStart, onDismiss }) => {
  const { betaNavigationVideoUrl } = useLazyLoadQuery<BetaNavigationVideoUrlQuery>(
    getBetaNavigationVideoUrl,
    { audience: isAdmin ? 'SITE_ADMIN' : 'TEACHER' },
    { fetchPolicy: 'store-or-network' },
  );

  return <BetaWelcomeDialog onStart={onStart} onDismiss={onDismiss} videoUrl={betaNavigationVideoUrl} />;
};

export const BetaWelcome: FC<Props> = ({ isAdmin, onStart, onDismiss }) => (
  <CustomErrorBoundary fallback={<BetaWelcomeDialog onStart={onStart} onDismiss={onDismiss} />}>
    <Suspense fallback={null}>
      <BetaWelcomeWithVideo isAdmin={isAdmin} onStart={onStart} onDismiss={onDismiss} />
    </Suspense>
  </CustomErrorBoundary>
);

export default BetaWelcome;
